import React from 'react';
import { useModal } from '../../context/ModalContext';
import './TimbradoDarkSection.css';

const TimbradoDarkSection = () => {
  const { openModal } = useModal();

  return (
    <section className="df-timbrado-dark-section" id="timbrado">
      <div className="df-timbrado-dark-container">
        {/* Encabezado: Texto y Tarjeta de Métrica 99.98% */}
        <div className="df-timbrado-dark-header">
          <div className="df-timbrado-dark-header-text">
            <span className="df-timbrado-dark-tag">TIMBRADO CORPORATIVO</span>
            <h2 className="df-timbrado-dark-title">
              Emite, valida y certifica CFDI ante el SAT con tiempos de{' '}
              <strong>70 a 100 ms por timbre</strong>.
            </h2>
            <p className="df-timbrado-dark-desc">
              Garantizando continuidad operativa y cumplimiento fiscal. Diseñado para casas de software, ERPs comerciales o desarrollos a la medida, desarrolladores e integradores.
            </p>
          </div>

          {/* Tarjeta de Disponibilidad */}
          <div className="df-timbrado-stat-card">
            <span className="df-timbrado-stat-number">99.98%</span>
            <span className="df-timbrado-stat-label">de disponibilidad · servicio 24 x 7 x 365</span>
          </div>
        </div>

        {/* 3 Tarjetas Blancas de Modalidad (Exactas a la propuesta) */}
        <div className="df-timbrado-white-cards-grid">
          {/* Tarjeta 01 */}
          <div className="df-timbrado-white-card">
            <span className="df-timbrado-card-number">01</span>
            <h3 className="df-timbrado-card-heading">Timbrado corporativo de CFDI</h3>
            <p className="df-timbrado-card-paragraph">
              Para la emisión y timbrado masivo de CFDI, nuestro servicio se integra a tus sistemas y aplicaciones para validar y certificar tus comprobantes ante el SAT de forma sencilla, sin afectar tu programación.
            </p>
          </div>

          {/* Tarjeta 02 */}
          <div className="df-timbrado-white-card">
            <span className="df-timbrado-card-number">02</span>
            <h3 className="df-timbrado-card-heading">Timbrado JSON</h3>
            <p className="df-timbrado-card-paragraph">
              Para que tu facturación electrónica no tenga problemas, generamos tus XML con facilidad a través de un formato de texto ligero, listos para ser validados y certificados por el SAT.
            </p>
          </div>

          {/* Tarjeta 03 */}
          <div className="df-timbrado-white-card">
            <span className="df-timbrado-card-number">03</span>
            <h3 className="df-timbrado-card-heading">Emisión y timbrado de CFDI</h3>
            <p className="df-timbrado-card-paragraph">
              Incorporamos por ti el sello digital a los XML de tus CFDI, para su posterior validación y timbrado.
            </p>
          </div>
        </div>

        {/* Botón Rojo: Contacta con un asesor */}
        <button
          type="button"
          className="df-timbrado-dark-btn"
          onClick={() => openModal('asesor')}
        >
          Contacta con un asesor
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M5 12h14M13 6l6 6-6 6"></path>
          </svg>
        </button>
      </div>
    </section>
  );
};

export default TimbradoDarkSection;
